var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lakasVisible()
             || _vm.eletVisible()
             || _vm.cascoVisible()
             || _vm.tobbjarmuVisible()
             || _vm.munkahelyVisible()
             || _vm.szerzAzonVisible()
             || _vm.greenCardVisible())?_c('AjanlatBase',{attrs:{"titleExtra":_vm.titleExtra}},[_c('v-form',{ref:"ajanlat-adatok",attrs:{"slot":"biztositoi-adatok"},slot:"biztositoi-adatok"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.lakasVisible())?_vm._l((_vm.getLakasDb()),function(x,index){return _c('BnFormField',{key:("groupama_szerz_azon2_" + index),attrs:{"attributes":{
                    type: 'text',
                    label: 'Lakásbiztosítás szerződés azonosító',
                    visible: true,
                    editable: true,
                    help: false,
                    path: 'tarifaData.groupama.tf_8_groupama_szerz_azon2_' + (x - 1),
                    mezo: 'groupama_szerz_azon2'
                }}})}):_vm._e(),_vm._v(" "),(_vm.eletVisible())?_vm._l((_vm.getEletDb()),function(x,index){return _c('BnFormField',{key:("groupama_szerz_azon4_" + index),attrs:{"attributes":{
                    type: 'text',
                    label: 'Életbiztosítás szerződés azonosító',
                    visible: true,
                    editable: true,
                    help: false,
                    path: 'tarifaData.groupama.tf_8_groupama_szerz_azon4_' + (x - 1),
                    mezo: 'groupama_szerz_azon4'
                }}})}):_vm._e(),_vm._v(" "),(_vm.cascoVisible())?_vm._l((_vm.getCascoDb()),function(x,index){return _c('BnFormField',{key:("tf_8_groupama_szerz_azon3_" + index),attrs:{"attributes":{
                    type: 'text',
                    label: 'Cascobiztosítás szerződés azonosító',
                    visible: true,
                    editable: true,
                    help: false,
                    path: 'tarifaData.groupama.tf_8_groupama_szerz_azon3_' + (x - 1),
                    mezo: 'tf_8_groupama_szerz_azon3_' + (x - 1)
                }}})}):_vm._e(),_vm._v(" "),(_vm.tobbjarmuVisible())?_vm._l((_vm.getTobbautoDb()),function(x,index){return _c('BnFormField',{key:("groupama_szerz_azon5_" + index),attrs:{"attributes":{
                    type: 'text',
                    label: 'Másik gépjármű szerződésszáma vagy ajánlatszáma',
                    visible: true,
                    editable: true,
                    help: false,
                    path: 'tarifaData.groupama.tf_8_groupama_szerz_azon5_' + (x - 1),
                    mezo: 'groupama_szerz_azon5'
                }}})}):_vm._e(),_vm._v(" "),(_vm.munkahelyVisible())?_c('BnFormField',{attrs:{"attributes":{
                type: 'select',
                label: 'Munkahely',
                visible: true,
                editable: true,
                help: true,
                path: 'tarifaData.kgfb_group_munkahely',
                mezo: 'kgfb_group_munkahely',
                resource: _vm.listTypes.groupama_munkahely,
                itemsText: 'value',
                itemsValue: 'key',
            }}}):_vm._e(),_vm._v(" "),(_vm.szerzAzonVisible())?_c('BnFormField',{attrs:{"attributes":{
                type: 'text',
                label: 'Preventor vagyon és felelősségbiztosítás szerződésszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'tf_8_groupama_szerz_azon6',
                path: 'tarifaData.groupama.tf_8_groupama_szerz_azon6',
            }}}):_vm._e(),_vm._v(" "),(_vm.greenCardVisible())?_c('BnFormField',{attrs:{"attributes":{
                type: 'select',
                label: 'Rendszeres Zöldkártya igénylés',
                visible: true,
                editable: true,
                help: true,
                path: 'tarifaData.groupama_zoldkartya_igenyles',
                mezo: 'groupama_zoldkartya_igenyles',
                resource: _vm.listTypes.groupama_zoldkartya_igenyles,
                default: _vm.listTypes.groupama_zoldkartya_igenyles[0],
                itemsText: 'value',
                itemsValue: 'key',
            }}}):_vm._e()],2)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }